<!-- View/routes wrapper-->
<router-outlet></router-outlet>
<div class="progress-loader" *ngIf="loading">
    <div class="loader"></div>
  </div>